var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEscalation = function SvgIconEscalation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background",
    d: "M13.429 26.858a13.41 13.41 0 0 0 13.429-13.429A13.41 13.41 0 0 0 13.429 0C5.998 0 0 6.027 0 13.429a13.41 13.41 0 0 0 13.429 13.429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    stroke: "#FFF",
    strokeWidth: 0.675,
    d: "M16.46 10.357a.82.82 0 0 0-.595-.232h-6.74c-1.06 0-1.06 1.654 0 1.654h4.789L4.29 21.403c-1.471 1.458-2.168 2.199-2.09 2.221.269.079.493.818 2.09 0 .226-.116.833-.68 1.819-1.692l8.962-8.963v4.79c0 1.058 1.654 1.058 1.654 0v-6.84c0-.232-.1-.43-.265-.562z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEscalation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-escalation.67a7864f8049349ed55db51becefd4d9.svg";